import Localizer from "@/localization/Localizer";
import DeviceGridHelper from "@/helpers/DeviceGridHelper";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import {pageData} from "@/helpers/CypressHelper";

describe('Desktop - Fleet Monitoring - Enabled alerts grid tests', () => {
    before(() => {
        cy.clearAllLocalStorage();
    });

    beforeEach(() => {
        cy.session(['company_role_session'], () => {
            cy.loginAndSelectCompanyRole("Urho.Kekkonen@weare.fi", "tmi jukka wilska");
        });
    });

    it('should render empty grid when no devices', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetDevicesPagedListEmpty.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        DeviceGridHelper.getEnabledAlertsGrid()
            .should('exist');

        // The grid is empty with a message
        DeviceGridHelper.getEnabledAlertsGrid()
            .should('contain', Localizer.fleetMonitoringPageGridEmpty);
    });

    it('should render grid correctly when there are devices', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        DeviceGridHelper.getEnabledAlertsGrid()
            .should('exist');

        // The grid has a header row and 2 data rows.
        DeviceGridHelper.getEnabledAlertsGrid()
            .children('div')
            .should('have.length', 3);

        // Check header titles.
        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(0, 0)
            .should('contain', Localizer.fleetMonitoringPageGridDeviceName);

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(0, 1)
            .should('contain', Localizer.fleetMonitoringPageGridId);

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(0, 2)
            .should('contain', Localizer.fleetMonitoringPageAlertSourcesSubscriptions);

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(1, 0, 1)
            .should('contain.text', 'Minigraver 1,8 Tonn / Diesel / S30 / Volvo EC18D');

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(1, 1)
            .should('contain', '4011');

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(2, 0, 1)
            .should('contain.text', 'Mastelift 5,66 M Batteri / Jlg 1230ES');

        DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(2, 1)
            .should('contain', '0370');
    });

    it('should render subscription icons correctly', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        DeviceGridHelper.getEnabledAlertsGrid()
            .should('exist');

        const expectedIconColorsRow1 = [
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
            RentaEasyConstants.Colors.supportedSubscriptionIconColor,
        ];
        const expectedIconColorsRow2 = [
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
        ];

        checkSubscriptionIconColors(1, expectedIconColorsRow1);
        checkSubscriptionIconColors(2, expectedIconColorsRow2);
    });

    it('should expand a row and display additional data', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});
        cy.intercept('GET', '/api/Fleet/getEnabledAlertDetails*', {fixture: 'getEnabledAlertDetails.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        const testedRow = 1;

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(testedRow)
            .click();

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', Localizer.genericConstructionSite);

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', 'Lager');

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', Localizer.genericCompany);

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', 'Stoltz Entreprenør AS');

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', Localizer.fleetMonitoringPageGridProductGroup);

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', 'Lift');

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', Localizer.fleetMonitoringPageGridDepot);

        DeviceGridHelper.getEnabledAlertsGridExpandedContentByRow(testedRow)
            .should('contain.text', 'Helsinki');
    });

    it('should expand a row and display alert subscriptions', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});
        cy.intercept('GET', '/api/Fleet/getEnabledAlertDetails*', {fixture: 'getEnabledAlertDetails.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        const testedRow = 1;

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(testedRow)
            .click();

        pageData().fleetMonitoring.enabledAlerts.fuelCheckbox('4011').should('not.exist');
        pageData().fleetMonitoring.enabledAlerts.batteryCheckbox('4011').verifyDataValue('true');
        pageData().fleetMonitoring.enabledAlerts.theftCheckbox('4011').verifyDataValue('true');
        pageData().fleetMonitoring.enabledAlerts.idleCheckbox('4011').verifyDataValue('false');
    });

    it('should delete battery alert and create idle alert for first device', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});
        cy.intercept('GET', '/api/Fleet/getEnabledAlertDetails*', {fixture: 'getEnabledAlertDetails.json'});
        cy.intercept('POST', '/api/Alarm/DeleteAlarm', { fixture: 'deleteAlarm.json' }).as('deleteAlarmRequest');
        cy.intercept('POST', '/api/Alarm/CreateDeviceUnusedFor3DaysAlarm', { fixture: 'createDeviceIdleAlarm.json' }).as('createAlarmRequest');

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        const testedRow = 1;

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(testedRow)
            .click();

        pageData().fleetMonitoring.enabledAlerts.saveButton('4011').should('be.disabled');
        pageData().fleetMonitoring.enabledAlerts.batteryCheckbox('4011').click();
        pageData().fleetMonitoring.enabledAlerts.idleCheckbox('4011').click();
        pageData().fleetMonitoring.enabledAlerts.saveButton('4011').should('not.be.disabled');
        pageData().fleetMonitoring.enabledAlerts.saveButton('4011').trigger('click');

        cy.waitSuccess('@deleteAlarmRequest');
        cy.waitSuccess('@createAlarmRequest');

        const expectedIconColorsRow1 = [
            RentaEasyConstants.Colors.supportedSubscriptionIconColor,
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
        ];

        checkSubscriptionIconColors(1, expectedIconColorsRow1);
    });

    it('should update fuel alert for the second device', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});
        cy.intercept('GET', '/api/Fleet/getEnabledAlertDetails*', {fixture: 'getEnabledAlertDetails.json'});
        cy.intercept('POST', '/api/Alarm/DeleteAlarm', { fixture: 'deleteAlarm.json' }).as('deleteAlarmRequest');
        cy.intercept('POST', '/api/Alarm/CreateDeviceFuelLevelAlarm', { fixture: 'createDeviceFuelLevelLessThanAlarm.json' }).as('createAlarmRequest');

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        const testedRow = 2;

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(testedRow)
            .click();

        pageData().fleetMonitoring.enabledAlerts.saveButton('0370').should('be.disabled');
        cy.setSliderValue('#slider', 50);
        pageData().fleetMonitoring.enabledAlerts.saveButton('0370').should('not.be.disabled');
        pageData().fleetMonitoring.enabledAlerts.saveButton('0370').trigger('click');

        cy.waitSuccess('@deleteAlarmRequest');
        cy.waitSuccess('@createAlarmRequest');

        const expectedIconColorsRow2 = [
            RentaEasyConstants.Colors.enabledSubscriptionIconColor,
        ];

        checkSubscriptionIconColors(testedRow, expectedIconColorsRow2);
    });

    it('should expand all/none rows with a single click on the header row', () => {
        cy.intercept('POST', '/api/Fleet/GetEnabledAlertsPagedList', {fixture: 'fleetGetEnabledAlertsPagedList.json'});
        cy.intercept('GET', '/api/Fleet/getEnabledAlertDetails*', {fixture: 'getEnabledAlertDetails.json'});

        cy.visit('/fleet-monitoring?selectedTab=h%C3%A4lytysl%C3%A4hteet');

        // Verify that the header arrow is directed down (some or none rows are expanded).
        DeviceGridHelper.getEnabledAlertsGridAngleIcon(0)
            .invoke('attr', 'class')
            .then((classList) => {
                expect(classList).to.not.contain('rotated');
            });

        // Click on all arrows (expand all rows).
        DeviceGridHelper.getEnabledAlertsGridAngleIcon(1)
            .click();

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(2)
            .click();

        // Verify that the header arrow is directed up now (all rows are expanded).
        DeviceGridHelper.getEnabledAlertsGridAngleIcon(0)
            .invoke('attr', 'class')
            .then((classList) => {
                expect(classList).to.contain('rotated');
            });

        // Click the header arrow and verify if all arrows are down too (all rows are closed).
        DeviceGridHelper.getEnabledAlertsGridAngleIcon(0)
            .click();

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(1)
            .invoke('attr', 'class')
            .then((classList) => {
                expect(classList).to.not.contain('rotated');
            });

        DeviceGridHelper.getEnabledAlertsGridAngleIcon(2)
            .invoke('attr', 'class')
            .then((classList) => {
                expect(classList).to.not.contain('rotated');
            });
    });

    const checkSubscriptionIconColors = (row: number, expectedColors: string[]) => {
        expectedColors.forEach((expectedColor, index) => {
            DeviceGridHelper.getEnabledAlertsGridContentByRowAndCell(row, 2)
                .find('svg')
                .eq(index)
                .children('path')
                .should('have.attr', 'fill', expectedColor);
        });
    };
});